<template>
    <div class="checkPhoto selected w-1/5 mb-6 px-2 relative cursor-pointer">
        <div class="groupItem">
            <img :data-mediaId="item?.MediaId" @click.prevent="$emit('preview', index)" :class="{
                selected: item.isAdded,
                fadeInOnMount: justMounted,
            }" class="w-full cursor-pointer" :src="item.Thumb" />

            <template v-if="item?.Status == 'Success'">
                <!-- Multimedio ya elegido -->
                <template v-if="item?.Available === true && !isAvailableForSale ">
                    <MediaSelector :item="item" :show="!isMobileDevice && album?.Unlocked"
                        @select="selectedMediaForDownload" />

                    <SaveImageButton v-if="isMobileDevice && album?.Unlocked && freeGallery" :imageUrl="item.Mink" :fileName="`${item?.MediaId}${item?.LocationId}.JPG`" />
                    <SaveImageButton v-else-if="isMobileDevice && album?.Unlocked" :imageUrl="item.Orig" :fileName="`${item?.MediaId}${item?.LocationId}.JPG`" />
                </template>

                <!-- Multimedio pendiente de elegir -->
                <template v-else-if="selectionLimitReached && item?.Available === false">
                    <div class="select absolute z-10" @click="userUnlockSelection(item)">
                        <div class="chooiseOption" :class="[item?.IsInCart && 'on']">
                            {{
                                item?.IsInCart
                                    ? $t("gallery.deselect_rollback")
                                    : $t("gallery.confirm_selection")
                            }}
                            <span class="material-icons">
                                {{
                                    item?.IsInCart
                                        ? "check_circle"
                                        : "radio_button_unchecked"
                                }}
                            </span>
                        </div>
                    </div>
                </template>

                <!-- Multimedios para compra -->
                <template v-else-if="mediaToBuy(item)">
                    <ActionIconButton :class="isInCartItem(item) ? 'bg-lightred-xcaret text-white' : 'bg-yellow-photo text-dark'" :icon="isInCartItem(item)
                        ? 'remove_shopping_cart'
                        : 'add_shopping_cart'" :label="isInCartItem(item)
                            ? $t('gallery.remove_from_cart')
                            : $t('gallery.add_to_cart')" @click="addCartByIndividual({
                                item,
                                album,
                                invoiceId: albumes?.invoiceId,
                            })" />
                </template>
                <template v-else></template>
            </template>
        </div>
    </div>
</template>

<script>
// Vuex
import { mapActions } from "vuex";
// Enums
import AlbumModeEnum from "@/enums/albumMode.js";
import AlbumSearchTypeEnum from "@/enums/searchType.js";
// Components
import MediaSelector from "@components/gallery/MediaSelector.vue";
import ActionIconButton from "@components/gallery/ActionIconButton.vue";
import SaveImageButton from '@components/gallery/SaveImageButton.vue';
// Helpers
import { isMobileDevice } from "@helpers/device.helper.js";

export default {
    name: "GalleryItem",
    props: {
        item: { type: Object, required: true },
        index: { type: Number, required: true },
        album: { type: Object, required: true },
        albumes: { type: Object, default: {} },
        isIndividualMediaSale: { type: Boolean, required: true },
        mediaMaxSelection: { type: Number, required: true },
        mediaPurchasedList: { type: Array, required: true },
        freeGallery: { type: Boolean, default: false },
    },
    components: {
        MediaSelector,
        ActionIconButton,
        SaveImageButton
    },
    data() {
        return {
            AlbumModeEnum,
            AlbumSearchTypeEnum,
            justMounted: true,
        };
    },
    methods: {
        ...mapActions("individualSales", ["addCartByIndividual"]),
        /**
         * Emit the selected multimedia item to the parent component.
         * @param {Object} item - The multimedia item to be selected.
         * @return {void}
         */
        selectedMediaForDownload(item) {
            this.$emit("selectedMediaForDownload", item);
        },
        /**
         * Emit the selected item for purchase to the parent component.
         * @param {Object} item - The item to be selected for purchase.
         * @return {void}
         */
        userUnlockSelection(item) {
            this.$emit("userUnlockSelection", item);
        },
        /**
         * Check if a value is within the valid range for media selection.
         * @param {number} value - The value to check.
         * @return {boolean} - True if the value is within range, false otherwise.
         */
        isInCartItem(item) {
            return (
                item?.IsInCart || this.album?.MediaIds?.includes(item?.MediaId)
            );
        },
        /**
         * Determine if the media item is available for purchase.
         * @param {Object} item - The media item to check.
         * @return {boolean} - True if the media is available for purchase, false otherwise.
         */
        mediaToBuy(item) {
            const hasAlbumMode =
                this.album?.AlbumMode == this.AlbumModeEnum.INDIVIDUAL_SALE;
            if (
                this.albumes?.Type == this.AlbumSearchTypeEnum.REGULARPARK &&
                hasAlbumMode
            ) {
                return true;
            }

            if (
                this.AlbumSearchTypeEnum.DOWNLOADCODE == this.albumes?.Type &&
                hasAlbumMode &&
                !item?.Available
            ) {
                return true;
            }

            return false;
        },
    },
    computed: {
        /**
         * Computed to detect if the device is mobile
         * @return {Boolean} - Returns true if the device is mobile
         */
        isMobileDevice() {
            return isMobileDevice();
        },
        /**
         * Check if the maximum selection limit has been reached.
         * @return {boolean} - True if the selection limit is reached, false otherwise.
         */
        selectionLimitReached() {
            return (
                this.album?.AlbumMode == this.AlbumModeEnum.INDIVIDUAL_SALE &&
                this.album?.DetailsServiceMedia?.Available > 0
            );
        },
        /**
        * Check if SearchType is for Regular Park and AlbumMode
        * @return {boolean} True if RegularPark & AlbumMode is 1, false otherwise.
        */
        isAvailableForSale() {
            return (
                this.album?.AlbumMode ===
                    this.AlbumModeEnum.INDIVIDUAL_SALE &&
                this.albumes?.Type ===
                    this.AlbumSearchTypeEnum.REGULARPARK
            );
        }
    },
    created() { },
    mounted() {
        setTimeout(() => {
            this.justMounted = false;
        }, 100);    },
};
</script>

<style scoped>
.chooiseOption {
    font-size: 6.5px;
    background-color: #fff;
    padding: 0 3px;
    line-height: 15px;
    border-radius: 5px;
    right: 20%;
    top: 58px;
    font-weight: 600;
    box-shadow: 0px 0px 5px rgb(0 0 0 / 65%);
    color: var(--color-text);
    text-shadow: none !important;
}

.chooiseOption.downloadOption {
    background-color: #ffe40a;
}

.chooiseOption span {
    top: 1px;
}

.chooiseOption.on {
    background-color: #dc2626;
    color: white;
}
</style>
